<template>
<div class="main">
	<h2>保障无效，请联系业务人员协助处理。</h2>
	<h3 v-if="info.name">业务专员：{{info.name}}</h3>
	<h3>咨询电话：{{info.phone}}</h3>
</div>
</template>
<script>
export default {
	data () {
		return {
			type:this.$route.query.type||'installer',
			contact:{
				'installer':{
					phone:'0532-88931655',
					name:'孟娜',
				},
				'storageV':{
					phone:'0532-88931683',
					name:'徐小涵',
				},
				'companyGroupEmployer':{
					phone:'18853258968',
					name:'',
				},
			}
		}
	},
	computed: {
		info(){
			return this.contact[this.type]
		}
	},
}
</script>
<style scoped lang="less">
	.main{
		padding: 20px 30px 100px;
		text-align: center;
		h2{
			margin-top: 50px;
		}
		h3{
			margin-top: 20px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/Error.vue